export function removeDuplicates(array) {
  var set = new Set();
  array.forEach(function (item) {
    return set.add(item);
  });
  return Array.from(set);
}
export function removeItem(array, item) {
  var index = array.indexOf(item);

  if (index >= 0) {
    array.splice(index, 1);
  }
}
export function isNonEmptyArray(value) {
  return Array.isArray(value) && value.length > 0;
}